var _defs, _circle, _g, _rect, _g2, _rect2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcon4(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 113.89 113.89",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#0c1f81;}.cls-2{fill:#ff8f0b;}.cls-3,.cls-4,.cls-5,.cls-6,.cls-7{fill:none;}.cls-3{stroke:#eaeced;}.cls-3,.cls-5{stroke-width:4px;}.cls-5,.cls-6,.cls-7{stroke:#fff;stroke-linecap:round;}.cls-5{stroke-miterlimit:10;}.cls-6{stroke-miterlimit:10;stroke-width:5px;}.cls-7{stroke-miterlimit:10;stroke-width:5px;}"))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_6-3",
    "data-name": "Ellipse 6-3",
    className: "cls-1",
    cx: 56.94,
    cy: 56.94,
    r: 56.94
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_5",
    "data-name": "Ellipse 5"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 56.53,
    cy: 57.63,
    r: 53.66
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 56.53,
    cy: 57.63,
    r: 51.66
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_67",
    "data-name": "Rectangle 67",
    className: "cls-4",
    x: 32.02,
    y: 30.05,
    width: 48.82,
    height: 54.9
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_346",
    "data-name": "Group 346"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_126",
    "data-name": "Path 126",
    className: "cls-5",
    d: "M78.78,74.78a25.91,25.91,0,1,1-2-36.59,25.17,25.17,0,0,1,2.89,3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_127",
    "data-name": "Path 127",
    className: "cls-6",
    d: "M42.13,65.58a21.63,21.63,0,0,0,11.54,9.48c4.93,1.83,9.08,1.37,14-.38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_128",
    "data-name": "Path 128",
    className: "cls-7",
    d: "M72.05,44.64a21.49,21.49,0,0,0-14.27-4.38c-5.26.18-8.92,2.18-12.84,5.69"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_129",
    "data-name": "Path 129",
    className: "cls-1",
    d: "M64.16,57.5A5.49,5.49,0,1,1,58.67,52a5.48,5.48,0,0,1,5.49,5.48"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_68",
    "data-name": "Rectangle 68",
    className: "cls-4",
    x: 32.02,
    y: 30.05,
    width: 48.82,
    height: 54.9
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon4);
export default __webpack_public_path__ + "static/media/Icon4.ef26c207f1264d4c1e272530b8b832b2.svg";
export { ForwardRef as ReactComponent };